import { Component } from '@angular/core';
import * as _ from 'lodash';
import { AppPlatforms } from 'src/app/enums/app-platforms.enum';
import { getAppPlatform } from 'src/app/util/app-platform';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  standalone: false
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  isIOSApp = getAppPlatform() === AppPlatforms.IOS;
  isAndroidApp = getAppPlatform() === AppPlatforms.ANDROID;
}
